import { Component, Inject } from "@angular/core";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent, DialogResolveData } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";

export interface IDataAuditDetailsDialogData {
    title: string;
    json: string;
}

interface IKeyValuePair {
    key: string;
    value: string;
}

@Component({
    selector: "adapt-data-audit-details-dialog",
    templateUrl: "./data-audit-details-dialog.component.html",
    standalone: false,
})
export class DataAuditDetailsDialogComponent extends BaseDialogComponent<IDataAuditDetailsDialogData, void> {
    public readonly dialogName = "DataAuditDetails";

    public keyValuePairs: IKeyValuePair[] = [];

    constructor(
        @Inject(ADAPT_DIALOG_DATA) public data: IDataAuditDetailsDialogData,
    ) {
        super(DialogResolveData.NotRequired);

        try {
            const parsed = JSON.parse(data.json);
            if (typeof parsed === "object" && parsed !== null) {
                this.keyValuePairs = Object.entries(parsed).map(([key, value]) => ({
                    key,
                    value: typeof value === "object" ? JSON.stringify(value, null, 4) : String(value),
                }));
            } else {
                this.keyValuePairs = [{ key: "Value", value: String(parsed) }];
            }
        } catch (e) {
            this.log.error(ErrorHandlingUtilities.getHttpResponseMessage(e), e);
            this.keyValuePairs = [{ key: "Raw Data (invalid JSON)", value: data.json }];
        }
    }

    public async copyValue(value: string) {
        await navigator.clipboard.writeText(value);
    }
}
